/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DistributeLeftEdgeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Distribute Left Edge',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.074 6H6V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v35a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V30h7.074a.926.926 0 0 0 .926-.926V6.926A.927.927 0 0 0 13.074 6ZM31 10h-7V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v35a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V26h7a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
